import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormDataService } from '../shared/form-data.service';
import { ConfigService } from '../shared/config.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {
  showSpinner: boolean;
  contentDetail: any;
  phoneNumber: any;
  easyClaimType: any;
  isEasyClaimType: boolean;
  isEasyClaimTLType: boolean;
  displayStyleTermsConditions: string;
  hasTLTermsAndConditions: boolean;
  enableTLAcceptBtn: boolean;
  tLTermsAndConditions: string;
  acceptButtonClass: string;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private configService: ConfigService,
    private formDataService: FormDataService,
  ) {
    this.contentDetail = this.configService.config.Data.contentDetail;
    this.phoneNumber = this.configService.config.Data.contentDetail.PhoneNumber.replace(/\s/g, "");
    this.easyClaimType = this.configService.config.Data.EasyClaimType;
    this.isEasyClaimType = false;
    this.isEasyClaimTLType = false;
    this.displayStyleTermsConditions = "none";
    this.hasTLTermsAndConditions = false;
    this.enableTLAcceptBtn = true;
    this.acceptButtonClass = "acceptBtnCls";
    if (this.easyClaimType == "EasyClaim") {
      this.isEasyClaimType = true;
    }
    else if (this.easyClaimType == "EasyClaimTL") {
      this.isEasyClaimTLType = true;
      this.hasTLTermsAndConditions = this.configService.config.Data.HasTLTermsAndConditions == "yes" ? true: false;
      this.enableTLAcceptBtn = !this.hasTLTermsAndConditions;
      this.tLTermsAndConditions = this.configService.config.Data.EcTLTermsAndConditions;
      if(this.hasTLTermsAndConditions)
      {
        this.acceptButtonClass = "acceptDeclineBtnCls";
      }
    }

  }

  ngOnInit() {
    console.log(this.contentDetail);
    let queryParam = this.route.snapshot.queryParamMap;
    if (queryParam !== null || typeof queryParam !== 'undefined') {
      let _vrn = queryParam.get('vrn');
      let _odometer = queryParam.get('odometer');
      let _accidentDate = queryParam.get('accidentDate');
      
      _vrn = (_vrn == null || typeof _vrn == 'undefined') ? "" : _vrn;
      _odometer = (_odometer == null || typeof _odometer == 'undefined') ? "" : _odometer;
      _accidentDate = (_accidentDate == null || typeof _accidentDate == 'undefined') ? "" : _accidentDate;

      localStorage.setItem("vrn", _vrn);
      localStorage.setItem("odometer", _odometer);
      localStorage.setItem("accidentDate", _accidentDate);
    }
  }

  gotoMain() {
    this.formDataService.setTimeStampType("p1welcomepagecontinuebtn");
    this.formDataService.setTimeStampDateTime(new Date().toUTCString());

    const http$ = this.formDataService.submitTimeStamp();
    http$.subscribe(res => {

    }, err => {
      console.log(err);

    });


    // this.router.navigate(['../main/photos'], {relativeTo: this.route});
    this.router.navigate(['../main/questions'], { relativeTo: this.route });
  }

  acceptOffer() {

    this.formDataService.setTimeStampType("p1welcomepagecontinuebtn");
    this.formDataService.setTimeStampDateTime(new Date().toUTCString());

    const http$ = this.formDataService.submitTimeStamp();
    http$.subscribe(res => {

    }, err => {
      console.log(err);

    });

    this.formDataService.setIsEasyClaimTlAcceptType(true);

    this.router.navigate(['../questions'], { relativeTo: this.route });
  }

  declineOffer() {

    this.formDataService.setTimeStampType("p1welcomepagecontinuebtn");
    this.formDataService.setTimeStampDateTime(new Date().toUTCString());

    const http$ = this.formDataService.submitTimeStamp();
    http$.subscribe(res => {

    }, err => {
      console.log(err);

    });

    this.formDataService.setIsEasyClaimTlAcceptType(false);
    //this.router.navigate(['../main/photos'], {relativeTo: this.route});
    this.router.navigate(['intermediate-easyclaim-tl']);
  }

  openTermsAndConditionPopup() {
    this.displayStyleTermsConditions = "block";
  }
  closeTermsAndConditionPopup() {
    this.displayStyleTermsConditions = "none";
  }
  acceptTLTermsConditions(event)
  {
    this.enableTLAcceptBtn = event.currentTarget.checked;
    
    if(event.currentTarget.checked)
    {
      this.acceptButtonClass = "acceptBtnCls";
    }
    else
    {
      this.acceptButtonClass = "acceptDeclineBtnCls";
    }
    
  }
}
